const cellPhoneRegExp = (): RegExp => {
  return new RegExp("^\\d{9}$");
};

export default cellPhoneRegExp;
